import { useTranslations } from 'next-intl';
import { BaseLineExclamation } from '@/app/components/icons/BaseLineExclamation';
import { useGlobalModal, useMembershipRevision, useQuota } from '@/app/hooks';
import { useStore } from '@/app/providers/store';
import type { SubsPlanType } from '@/app/types';
import { isUltimateOrHigherPlan, reportEvent } from '@/app/utils';

/**
 * 对话框底部提示组件
 * @description 显示元素数量限制和升级提示
 */
export const DialogFooterTip = () => {
  const t = useTranslations();
  const { open: openPlanDialog } = useGlobalModal('planDetailDialog');
  const { userInfo, isTeamSpace } = useStore((state) => ({
    userInfo: state.userInfo,
    isTeamSpace: state.isTeamSpace,
  }));

  const subsPlan = (userInfo?.subs_plan || 'free') as SubsPlanType;
  const { elementMonthlyLimit } = useQuota();
  const isNewMembership = useMembershipRevision();
  const hasMaxElementQuota =
    isUltimateOrHigherPlan(subsPlan) || (!isTeamSpace && isNewMembership === true && subsPlan !== 'free');
  const tipKey = subsPlan === 'free' ? 'subscribeMoreTip' : hasMaxElementQuota ? 'bottomTip' : 'upgradeMoreTip';

  return (
    <div className="mt-4 flex flex-row items-center justify-center gap-1.5 px-6 text-[#828282] text-xs">
      <BaseLineExclamation className="size-4 shrink-0 text-[#828282]" />
      <span className="truncate">
        {isTeamSpace
          ? t('elements.elementDialog.teamLimitTip', {
              num: elementMonthlyLimit,
            })
          : t(`elements.elementDialog.${tipKey}`, {
              num: elementMonthlyLimit,
              plan: t(`payments.${subsPlan}`),
            })}
      </span>
      {!hasMaxElementQuota && (
        <span
          className="shrink-0 cursor-pointer text-system-blue02"
          onClick={() => {
            openPlanDialog({ fromPage: 'reference' });
            reportEvent('vip_price_modal_exposure', {
              from_page: 'reference',
            });
          }}
        >
          {subsPlan === 'free' ? t('elements.elementDialog.subscribe') : t('elements.elementDialog.upgrade')}
        </span>
      )}
    </div>
  );
};
